import { type } from 'arktype';

import { stringMaxLength, stringRequiredAndMaxLength } from '@/schemas/utils';

export const addressSchema = type({
  street: type('string').narrow(stringRequiredAndMaxLength(70)),
  complement: type('string').narrow(stringMaxLength(16)),
  city: type('string').narrow(stringRequiredAndMaxLength(20)),
  state: type('string > 0 | null').configure({ message: 'VALIDATION_REQUIRED' }),
  zipCode: type('string > 0').configure({ message: 'VALIDATION_REQUIRED' }),
});

// SWIFT addresses allow an empty zipCode because some countries (e.g. Hong Kong)
// don't have postcodes. The required-when-not-HK rule is enforced at the parent
// schema level via a narrow on `fiatSwiftPaymentMethodSchema`.
export const swiftAddressSchema = type({
  street: type('string').narrow(stringRequiredAndMaxLength(70)),
  complement: type('string').narrow(stringMaxLength(16)),
  city: type('string').narrow(stringRequiredAndMaxLength(20)),
  state: type('string > 0 | null').configure({ message: 'VALIDATION_REQUIRED' }),
  zipCode: type('string'),
});

export const addressSchemaPartial = type({
  'address?': addressSchema,
});
